import React from 'react';
import { Helmet } from 'react-helmet';
import PageWrapper from 'components/pageWrapper';
import Content from './content';
import classes from './styles.module.scss';

const Terms = () => {
  return (
    <>
      <Helmet>
        <title>Terms & Conditions</title>
      </Helmet>
      <PageWrapper heading="Terms & Conditions">
        <div className={classes.wrapper}>
          <Content />
        </div>
      </PageWrapper>
    </>
  );
};

export default Terms;
